export class CpeAbstract {
  protected mostrarRequerimentogeral = false;
  protected mostrarDesaquirvamentoAutos = false;
}


